import React, { useCallback, useEffect, useMemo, useState } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";

import toastr from "toastr";

import {
  initialForm,
  initialAssetDetails,
  initialEvidence,
  initialPersonalDetails,
  initialVehicleDetails,
  staffNameRule,
  otherstaffNameRule,
  otherSubAreaValidation,
  incidentReportRules,
  assetDetailsRules,
  evidenceRules,
  personalDetailsRules,
  vehicleDetailsRules,
  evidenceCategories,
  incidentStatuses,
  GETVAL,
  capaRoRules,
  GET_MSSG_WITH_VALIDATE_LTI_FATALITY,
} from "./CONSTANTS";

import { initialCapa, capaRules } from "../IncidentManagement/CONSTANTS";

import {
  createIncidentReport,
  getIncidentReportById,
  updateIncidentReport,
} from "app/_services/ehs/ehsIncidentServices";

import { StateService } from "app/_services/ConfigService/StateService/StateService";
import { CountryService } from "app/_services/ConfigService/CountryService/CountryService";
import { getDepartment } from "app/_services/UserManagement/DepartmentService";
import { UserService } from "app/_services/UserService/UserService";
import { Validation } from "app/_helpers/validation/Validation";
import { getAllSites } from "app/_services/ehs/ehsSiteServices";
import {
  isAfterHoursMinutes,
  normalizeDateTime,
  capitalizeName,
  SORT_BY_ALPHABETICALLY,
} from "app/_helpers/helper";
import { CommmonService } from "app/_services/CommonService/CommonService";
import { getAllAreaOfOperation } from "app/_services/ehs/ehsAreaOfOperationServices";
import { getAllActivity } from "app/_services/_globalConfiguration/Activity/ActivityService";
import { getContractor } from "app/_services/Contractor/ContractorService";
import { getCapaOwner } from "../../../_services/ehs/ehsCapaOwner";

import IncidentInfoTab from "./Component/ReportForm/IncidentInfoTab";
import GeneralInfoTab from "./Component/ReportForm/GeneralInfoTab";
import PersonnelDetailsTab from "./Component/ReportForm/PersonnelDetailsTab";
import EquipmentDetailsTab from "./Component/ReportForm/EquipmentDetailsTab";
import VehicleDetailsTab from "./Component/ReportForm/VehicleDetailsTab";
import IncidentEvidenceTab from "./Component/ReportForm/IncidentEvidenceTab";
import IncidentCapaTab from "./Component/ReportForm/IncidentCapaTab";

import { ACTIVE_MODULE } from "app/_constants/constant";
import {
  getSubmitButtonText,
  getReportAtLabelByStatus,
  IS_USER_SITE_MINES,
  LOGGED_USER_ID,
} from "./Helper";
import { getEmployee } from "app/_services/UserManagement/EmployeeService";
import { getAllContractorPerson } from "app/_services/UserManagement/ContractorPersonService";
import moment from "moment";
import ViewComments from "./ViewComments";
import { Col } from "react-bootstrap";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { GoPrimitiveDot } from "react-icons/go";
import groupArray from "group-array";
import ErrorPopup from "./ErrorPopup";
import { confirmAlert } from "react-confirm-alert";
import {
  useContractorDropdown,
  useContractorPersonDropdown,
  useEmployeeDropdown,
} from "app/_helpers/hooks";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

export const permitShifts = {
  shiftOne: "I",
  shiftTwo: "II",
  shiftThree: "III",
  shiftFour: "General",
};

export const checkForLt = (personalDetails) => {
  const checkLtiHours = personalDetails?.find((d) => {
    return +d?.ltiHours > 0 && !d?.deleted;
  });
  if (!checkLtiHours) {
    return "Atleast 1 LTI Hour record Should Be Greater Than 0 Hour for LTI incident type";
  }
};

const ManageIncidentReport = ({ match: { params }, history }) => {
  const [form, setForm] = useState({
    ...initialForm,
    id: params.id || null,
    siteId: params.siteId || "",
    peopleCount: 0,
    fatalityEmployees: 0,
    fatalityContractors: 0,
    fatalityOthers: 0,
    injuredEmployees: 0,
    injuredContractors: 0,
    injuredOthers: 0,
    lostManhoursEmployees: 0,
    lostManhoursContractors: 0,
    lostManhoursOthers: 0,
    incidentDate: moment().format("YYYY-MM-DD HH:mm"),
    reportDate: moment().format("YYYY-MM-DD HH:mm"),
  });
  const [sites, setSites] = useState([]);
  const [errorForm, setErrorForm] = useState({
    ...initialForm,
    ...initialCapa,
  });
  const [tab, setTab] = useState(1);

  const [personalDetails, setPersonalDetails] = useState([
    JSON.parse(JSON.stringify(initialPersonalDetails)),
  ]);
  const [assetDetails, setAssetDetails] = useState([
    JSON.parse(JSON.stringify(initialAssetDetails)),
  ]);
  const [vehicleDetails, setVehicleDetails] = useState([
    JSON.parse(JSON.stringify(initialVehicleDetails)),
  ]);

  const [evidences, setEvidences] = useState([
    JSON.parse(JSON.stringify(initialEvidence)),
  ]);
  const [personalDetailsErrors, setPersonalDetailsErrors] = useState([]);
  const [assetDetailsErrors, setAssetDetailsErrors] = useState([]);
  const [vehicleDetailsErrors, setVehicleDetailsErrors] = useState([]);
  const [evidencesErrors, setEvidencesErrors] = useState([]);

  const [area, setArea] = useState([]);
  const [subArea, setSubArea] = useState([]);
  const [activity, setActivity] = useState([]);
  const [subActivity, setSubActivity] = useState([]);
  const [disableEmployer, setDisableEmployer] = useState(true);
  // const [contractors, setContractors] = useState([]);
  const [contractorsStaff, setContractorsStaff] = useState([]);
  const [capasErrors, setCapasErrors] = useState([]);
  const [incidentDetailsId, setincidentDetailsId] = useState(form?.id);
  const [capas, setCapas] = useState([]);

  const [capaOwners, setCapaOwners] = useState([]);
  const [otherSubArea, setOtherSubArea] = useState();

  // CUSTOM HOOKS
  const [contractors] = useContractorDropdown();
  const [contractorPersons] = useContractorPersonDropdown();
  const [employees] = useEmployeeDropdown();

  // DataBase DATA
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [mats, setMats] = useState([{ id: 1, name: "EP 1" }]);
  const [employeeList, setEmployeeList] = useState([]);
  const [tabComplete, setTabComplete] = useState(null);
  const [personnelDetailsTabComplete, setPersonnelDetailsTabComplete] = useState(null);
  const [equipmentDetailsTabComplete, setEquipmentDetailsTabComplete] = useState(null);
  const [vehicleDetailsTabComplete, setVehicleDetailsTabComplete] = useState(null);
  const [evidenceTabComplete, setEvidenceTabComplete] = useState(null);
  const [capaTabComplete, setCapaTabComplete] = useState(null);
  const [show, setShow] = useState(false);
  const [popupMssg, setPopupMssg] = useState("");
  const [isOptionalPopup, setIsOptionalPopup] = useState(false);
  const [submitFlagPass, setSubmitFlagPass] = useState({});

  // const [mats, setMats] = useState([]); // Mat === Material Master;
  const [matDetails, setMatDetails] = useState([
    { id: 1, name: "DTH Drill Machine" },
    { id: 2, name: "Jack hammer" },
    { id: 3, name: "Long Hole/Ring Drilling Machine" },
    { id: 4, name: "Exploration Drill Machine" },
    { id: 5, name: "Excavator" },
    { id: 6, name: "Payloader" },
    { id: 7, name: "Dumper" },
    { id: 8, name: "Tipper-Truck" },
    { id: 9, name: "Buyer's Truck" },
    { id: 10, name: "Explosive Van" },
    { id: 11, name: "Trailer" },
    { id: 12, name: "Dozer" },
    { id: 13, name: "Grader" },
    { id: 14, name: "Mobile Screening Plant" },
    { id: 15, name: "Mobile Crusher Plant" },
    { id: 16, name: "Fixed Crushing & Sizing Plant" },
    { id: 17, name: "Light Vehicle" },
    { id: 18, name: "Over Head Crane" },
    { id: 19, name: "Hoists & Other Cranes" },
    { id: 20, name: "Hydra & Mobile Cranes" },
    { id: 21, name: "Forklift" },
    { id: 22, name: "Pump" },
    { id: 23, name: "Submersible Pump" },
    { id: 24, name: "Sub-Station" },
    { id: 25, name: "Transformer" },
    { id: 26, name: "DG Set" },
    { id: 27, name: "Electrical OH Lines & Cablea" },
    { id: 28, name: "Lathe Machine" },
    { id: 29, name: "Grinding & Cutting Machine" },
    { id: 30, name: "Welding Machine " },
    { id: 31, name: "Compressors" },
    { id: 32, name: "Pressure Tank" },
    { id: 33, name: "Rocker Shovel" },
    { id: 34, name: "Haulage" },
    { id: 35, name: "Locomotive" },
    { id: 36, name: "Winder" },
    { id: 37, name: "Ventilation Main Fan" },
    { id: 38, name: "Auxiliary/Booster Fan" },
    { id: 39, name: "Others" },
  ]); // Mat Details === Material Master Level 4;

  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(false);

  const finalForm = useMemo(() => {
    setForm((prev) => {
      if (IS_USER_SITE_MINES()) {
        const obj =
          sites.length !== 0
            ? {
                siteId: sites[0]?.id,
                stateMasterId: sites[0]?.state.id,
                countryMasterId: sites[0]?.state.country_master?.id,
                locationSiteId: sites[0]?.siteId,
                roId: sites[0]?.parentSite?.id,
                roName: sites[0]?.parentSite?.name,
                roSiteId: sites[0]?.parentSite?.siteId,
              }
            : {};
        return { ...prev, ...obj };
      } else return prev;
    });
  }, [sites]);

  useEffect(() => {
    setCapas((prev) =>
      prev.map((d) => ({
        ...d,
        completionDate: form.incidentDate,
      }))
    );
  }, [form.incidentDate]);

  // FORM FUNCTION(s)
  const onChange = ({ target: { name, type, value, checked } }) => {
    if (type === "checkbox" && !checked)
      switch (name) {
        case "reportEvidencesRequired":
          if (evidences?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "isPersonalInjury":
          if (personalDetails?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "isAssetIncident":
          if (assetDetails?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;
        case "isVehicleIncident":
          if (vehicleDetails?.filter((data) => !data.deleted).length)
            return toastr.warning("Please delete all rows first!");
          break;

        default:
          break;
      }

    setForm((prevForm) => {
      const updates = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      if (name === "isPersonalInjury" && !checked) updates.peopleCount = 0;
      if (name === "injuryInfoRequired" && !checked) {
        updates.fatalityEmployees = 0;
        updates.fatalityContractors = 0;
        updates.fatalityOthers = 0;
        updates.injuredEmployees = 0;
        updates.injuredContractors = 0;
        updates.injuredOthers = 0;
        updates.lostManhoursEmployees = 0;
        updates.lostManhoursContractors = 0;
        updates.lostManhoursOthers = 0;
      }
      if (name === "siteId") {
        const selected = sites.find((site) => site.id === +value);
        if (selected) {
          updates.stateMasterId = selected.state.id;
          updates.countryMasterId = selected.state.country_master?.id;
          updates.locationSiteId = selected.siteId;
          if (selected.siteType === 3) {
            updates.roId = selected.parentSite?.id;
            updates.roName = selected.parentSite?.name;
            updates.roSiteId = selected.parentSite?.siteId;
          } else if (selected.siteType === 2) {
            updates.roId = selected.id;
            updates.roName = selected.name;
            updates.roSiteId = selected.siteId;
          } else {
            updates.roId = "";
            updates.roName = "";
            updates.roSiteId = "";
          }
        } else {
          updates.stateMasterId = "";
          updates.countryMasterId = "";
          updates.locationSiteId = "";
          updates.roId = "";
          updates.roName = "";
          updates.roSiteId = "";
        }
      }

      // Unset severity on type change
      if (name === "type") {
        updates.severity = "";
      }

      if (name === "staffType") {
        if (value === GETVAL.employee) {
          updates.staffEmployer = GETVAL.omc;
          updates.staffName = "";
          setDisableEmployer(true);
        } else if (value === GETVAL.others) {
          updates.staffEmployer = GETVAL.others;
          setDisableEmployer(true);
        } else {
          updates.staffEmployer = "";
          updates.staffName = "";
          setDisableEmployer(false);
        }
      }

      if (name === "staffName") {
        if (updates.staffType === GETVAL.contractor) {
          const selected = contractorsStaff.find((staff) => staff.id === +value);
          if (selected) {
            updates.staffEmployer = +selected?.contractorId;
          }
          setDisableEmployer(false);
        }
      }

      // if (name === "staffEmployer") {
      //   const selected = contractors.find((contractor) => contractor.id === +value);
      //   if (selected?.contractorPersons) {
      //     setContractorsStaff(selected?.contractorPersons);
      //   } else {
      //     setContractorsStaff([]);
      //   }
      // }

      return updates;
    });
    changeDependentDropdown(name, value);
  };

  const changeDependentDropdown = (name, value) => {
    let filterData = [];
    switch (name) {
      case "areaId":
        setSubArea(filterData);
        if (area.length) {
          filterData = area?.find((x) => x.id === value)?.subAreaOfOperation;
          const subAreaResult = filterData.filter((x) => x.id === 999);
          if (!subAreaResult.length) {
            filterData.push({ id: 999, name: "Other" });
          }
          let subAreaData = [...filterData];
          if (subAreaData.length) {
            setSubArea(subAreaData);
          }

          // Unset SubArea Values;
          if (form.areaId !== value) {
            setForm((prevForm) => ({
              ...prevForm,
              subAreaId: "",
            }));
          }
        }
        break;
      case "activityId":
        setSubActivity(filterData);
        if (activity.length) {
          filterData = activity.find((x) => x.id === value).subActivity;
          if (filterData.length) {
            setSubActivity(filterData);
          }
        }
        break;
    }
  };

  const onChangeDate = (momentDate, name) => {
    if (typeof momentDate === "string") return;
    setForm((prevForm) => ({
      ...prevForm,
      [name]: momentDate.format("YYYY-MM-DD HH:mm:ss"),
    }));
  };

  /************************* IncidentInfoTab **********************/
  /************************* GeneralInfoTab **********************/
  /************************* PersonnelDetailsTab **********************/
  // PERSONAL DETAILS FUNCTION(s)
  const addRowPersonalDetails = () => {
    if (!form.isPersonalInjury)
      return toastr.warning("Please enable 'Personal Injury' first!");
    setPersonalDetails((prev) => [
      ...prev,
      JSON.parse(JSON.stringify(initialPersonalDetails)),
    ]);
  };

  const onChangePersonalDetails = (index, name, value) => {
    setPersonalDetails((prev) =>
      prev.map((d, idx) => {
        if (idx !== index) return d;

        d[name] = value;
        if (name === "type") {
          if (value === "Employee") {
            d.employer = GETVAL.omc;
          } else if (value === "Others") {
            d.employer = GETVAL.Others;
          }
          d.name = "";
          d.userId = null;
        }

        if (name === "bodyParts" && value?.split(",")?.includes("notApplicable")) {
          d.bodyParts = "notApplicable";
        }

        if (name === "outcome") {
          d.ltiHours = 0;
        }

        return d;
      })
    );
  };

  const onChangePersonalDetailsEmployee = (index, name, userId, dob) => {
    setPersonalDetails((prev) =>
      prev.map((d, idx) => {
        if (idx === index) {
          if (d.type === "Contractor") {
            const selected = contractorsStaff.find((staff) => staff.id === +userId);
            if (selected) {
              d.employer = +selected?.contractorId;
            }
          }
        }
        return idx !== index
          ? d
          : {
              ...d,
              name,
              userId,
              //phone,
              age: dob ? CommmonService.getAge(dob) : "",
            };
      })
    );
  };

  const deleteRowPersonalDetails = (index) => {
    setPersonalDetails((prev) => {
      if (prev[index].id) prev[index].deleted = 1;
      else prev.splice(index, 1);

      return [...prev];
    });
  };

  /************************* EquipmentDetailsTab **********************/
  // ASSET DETAILS FUNCTION(s)
  const addRowAssetDetails = () => {
    if (!form.isAssetIncident)
      return toastr.warning("Please enable 'Equipment Details' first!");
    setAssetDetails((prev) => [...prev, JSON.parse(JSON.stringify(initialAssetDetails))]);
  };

  const onChangeAssetDetails = (index, name, value) => {
    setAssetDetails((prev) =>
      prev.map((d, idx) => (idx !== index ? d : { ...d, [name]: value }))
    );
  };

  const onChangeAssetDetailsSku = (index, levelFour) => {
    const { name, sku, id } = levelFour;
    setAssetDetails((prev) =>
      prev.map((d, idx) => (idx !== index ? d : { ...d, name, sku, detailsId: id }))
    );
  };

  const onChangeAssetDetailsSkuInput = (index, value) => {
    if (value)
      setAssetDetails((prev) =>
        prev.map((d, idx) => (idx !== index ? d : { ...d, sku: value, detailsId: null }))
      );
  };

  const deleteRowAssetDetails = (index) => {
    setAssetDetails((prev) => {
      if (prev[index].id) prev[index].deleted = 1;
      else prev.splice(index, 1);

      return [...prev];
    });
  };

  /************************* VehicleDetailsTab **********************/
  // VEHICLE DETAILS FUNCTION(s)
  const addRowVehicleDetails = () => {
    if (!form.isVehicleIncident)
      return toastr.warning("Please enable 'Vehicle Details' first!");
    setVehicleDetails((prev) => [
      ...prev,
      JSON.parse(JSON.stringify(initialVehicleDetails)),
    ]);
  };

  const onChangeVehicleDetails = (index, name, value) => {
    setVehicleDetails((prev) =>
      prev.map((d, idx) => (idx !== index ? d : { ...d, [name]: value }))
    );
  };

  const deleteRowVehicleDetails = (index) => {
    setVehicleDetails((prev) => {
      if (prev[index].id) prev[index].deleted = 1;
      else prev.splice(index, 1);

      return [...prev];
    });
  };
  /************************* IncidentEvidenceTab **********************/
  // EVIDENCE FUNCTION(s)
  const addEvidence = () =>
    setEvidences((previous) => [
      ...previous,
      JSON.parse(JSON.stringify(initialEvidence)),
    ]);

  const onChangeEvidence = ({ name, value, type, checked, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  const onChangeEvidenceFile = ({ responseData, index }) => {
    setEvidences((prevEvidences) =>
      prevEvidences.map((data, idx) => {
        if (idx !== index) return data;

        data.file = responseData;
        data.fileId = responseData.id;

        return data;
      })
    );
  };

  const deleteEvidence = (index) =>
    setEvidences((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );

  const errorObjByTab = useCallback(
    (data) => {
      const gData = groupArray(data, "tab");

      const obj = {};
      for (let key in gData) {
        key = +key;
        const element = gData[key];
        obj[key] = Object.values(Validation(form, element)).filter((d) => d !== "").length
          ? false
          : true;
      }

      return obj;
    },
    [form]
  );

  const checkTabValidation = useCallback(() => {
    let finalIncidentReportRules = incidentReportRules;
    if (form.staffType === "others") {
      finalIncidentReportRules.push(otherstaffNameRule);
      finalIncidentReportRules = finalIncidentReportRules?.filter(
        (d) => d?.field_name !== "staffName"
      );
    } else if (form.staffType === "contractor") {
      finalIncidentReportRules.push(staffNameRule);
      finalIncidentReportRules = finalIncidentReportRules?.filter(
        (d) => d?.field_name !== "otherStaffName"
      );
    } else if (form.staffType === "employee") {
      finalIncidentReportRules.push(staffNameRule);
      finalIncidentReportRules = finalIncidentReportRules?.filter(
        (d) => d?.field_name !== "otherStaffName"
      );
    }

    if (form.subAreaId === parseInt(999) && form.otherSubArea === "") {
      finalIncidentReportRules.push(otherSubAreaValidation);
    } else
      finalIncidentReportRules = finalIncidentReportRules?.filter(
        (d) => d?.field_name !== "otherSubArea"
      );

    const obj = errorObjByTab(finalIncidentReportRules);

    if (form.isPersonalInjury && (form.peopleCount < 1 || !personalDetails.length))
      obj["3"] = false;
    else obj["3"] = true;

    if (form.isAssetIncident && !assetDetails.length) obj["4"] = false;
    else obj["4"] = true;

    if (form.isVehicleIncident && !vehicleDetails.length) obj["5"] = false;
    else obj["5"] = true;

    if (form.reportEvidencesRequired && !evidences.length) obj["6"] = false;
    else obj["6"] = true;

    setTabComplete(obj);
  }, [
    assetDetails.length,
    errorObjByTab,
    evidences.length,
    form.isAssetIncident,
    form.isPersonalInjury,
    form.isVehicleIncident,
    form.otherSubArea,
    form.peopleCount,
    form.reportEvidencesRequired,
    form.staffType,
    form.subAreaId,
    personalDetails.length,
    vehicleDetails.length,
  ]);

  useEffect(() => {
    checkTabValidation();
  }, [checkTabValidation]);

  const errorObjPersonnelDetailsTab = useCallback(() => {
    let checkTabError = true;
    const personalDetailsErrorArray = form.isPersonalInjury
      ? personalDetails.map((data) =>
          data.deleted ? {} : Validation(data, personalDetailsRules)
        )
      : [];

    for (const array of [personalDetailsErrorArray])
      for (const errObj of array)
        for (const key in errObj)
          if (errObj[key]) {
            checkTabError = false;
          }
    setPersonnelDetailsTabComplete(checkTabError);
  }, [form.isPersonalInjury, personalDetails]);

  useEffect(() => {
    errorObjPersonnelDetailsTab();
  }, [errorObjPersonnelDetailsTab]);

  const errorObjEquipmentDetailsTab = useCallback(() => {
    let checkTabError = true;
    const assetDetailsErrorArray = form.isAssetIncident
      ? assetDetails.map((data) =>
          data.deleted ? {} : Validation(data, assetDetailsRules)
        )
      : [];

    for (const array of [assetDetailsErrorArray])
      for (const errObj of array)
        for (const key in errObj)
          if (errObj[key]) {
            checkTabError = false;
          }
    setEquipmentDetailsTabComplete(checkTabError);
  }, [assetDetails, form.isAssetIncident]);

  useEffect(() => {
    errorObjEquipmentDetailsTab();
  }, [errorObjEquipmentDetailsTab]);

  const errorObjVehicleDetailsTab = useCallback(() => {
    let checkTabError = true;
    const vehicleDetailsErrorArray = form.isVehicleIncident
      ? vehicleDetails.map((data) =>
          data.deleted ? {} : Validation(data, vehicleDetailsRules)
        )
      : [];

    for (const array of [vehicleDetailsErrorArray])
      for (const errObj of array)
        for (const key in errObj)
          if (errObj[key]) {
            checkTabError = false;
          }
    setVehicleDetailsTabComplete(checkTabError);
  }, [form.isVehicleIncident, vehicleDetails]);

  useEffect(() => {
    errorObjVehicleDetailsTab();
  }, [errorObjVehicleDetailsTab]);

  const errorObjEvidenceTab = useCallback(() => {
    let checkTabError = true;
    const evidencesErrorArray = form.reportEvidencesRequired
      ? evidences.map((data) => (data.deleted ? {} : Validation(data, evidenceRules)))
      : [];

    for (const array of [evidencesErrorArray])
      for (const errObj of array)
        for (const key in errObj)
          if (errObj[key]) {
            checkTabError = false;
          }
    setEvidenceTabComplete(checkTabError);
  }, [evidences, form.reportEvidencesRequired]);

  useEffect(() => {
    errorObjEvidenceTab();
  }, [errorObjEvidenceTab]);

  const errorObjCapaTab = useCallback(() => {
    let checkTabError = true;
    const capaErrorArray = capas.map((data) =>
      data.deleted
        ? {}
        : Validation(
            data,
            form.reportAtLabel === "ro"
              ? capaRoRules?.map((d) =>
                  d?.field_name === "otherSubArea"
                    ? data?.subAreaId === 999
                      ? { ...d, isRequired: true }
                      : { ...d, isRequired: false }
                    : d
                )
              : capaRules
          )
    );

    for (const errObj of capaErrorArray)
      for (const key in errObj)
        if (errObj[key]) {
          checkTabError = false;
        }
    setCapaTabComplete(checkTabError);
  }, [capas, form.reportAtLabel]);

  useEffect(() => {
    errorObjCapaTab();
  }, [errorObjCapaTab]);

  // console.log("formCheckkkk", form);

  /********************** SUBMIT **************** */
  // SUBMIT FUNCTION
  const onSubmit = useCallback(
    async (
      incidentStatus = incidentStatuses.draft,
      validate = true,
      dontGoBack = false,
      onCallPopup = false
    ) => {
      if (saving) return;
      setSaving(true);

      // const toast = toastr.warning("Saving, please wait...");

      let flag = 0;
      let capaFlag = 0;
      let finalIncidentReportRules = incidentReportRules;

      if (form.staffType === "others") {
        finalIncidentReportRules.push(otherstaffNameRule);
        finalIncidentReportRules = finalIncidentReportRules?.filter(
          (d) => d?.field_name !== "staffName"
        );
      } else if (form.staffType === "contractor" || form.staffType === "employee") {
        finalIncidentReportRules.push(staffNameRule);
        finalIncidentReportRules = finalIncidentReportRules?.filter(
          (d) => d?.field_name !== "otherStaffName"
        );
      } else if (form.staffType != "employee" && form.staffName == "") {
        finalIncidentReportRules.push(staffNameRule);
      }
      if (form.subAreaId === parseInt(999) && form.otherSubArea == "") {
        finalIncidentReportRules.push(otherSubAreaValidation);
      }

      const errorObj = Validation(form, finalIncidentReportRules);

      const personalDetailsErrorArray = form.isPersonalInjury
        ? personalDetails.map((data) =>
            data.deleted ? {} : Validation(data, personalDetailsRules)
          )
        : [];

      const assetDetailsErrorArray = form.isAssetIncident
        ? assetDetails.map((data) =>
            data.deleted ? {} : Validation(data, assetDetailsRules)
          )
        : [];

      const vehicleDetailsErrorArray = form.isVehicleIncident
        ? vehicleDetails.map((data) =>
            data.deleted ? {} : Validation(data, vehicleDetailsRules)
          )
        : [];

      const evidencesErrorArray = form.reportEvidencesRequired
        ? evidences.map((data) => (data.deleted ? {} : Validation(data, evidenceRules)))
        : [];

      const capaErrorArray = capas.map((data) =>
        data.deleted
          ? {}
          : Validation(
              data,
              form.reportAtLabel === "ro"
                ? capaRoRules?.map((d) =>
                    d?.field_name === "otherSubArea"
                      ? data?.subAreaId === 999
                        ? { ...d, isRequired: true }
                        : { ...d, isRequired: false }
                      : d
                  )
                : capaRules
            )
      );

      if (
        form.injuryInfoRequired &&
        !+form.fatalityContractors &&
        !+form.fatalityEmployees &&
        !+form.fatalityOthers &&
        !+form.injuredContractors &&
        !+form.injuredEmployees &&
        !+form.injuredOthers &&
        !+form.lostManhoursContractors &&
        !+form.lostManhoursEmployees &&
        !+form.lostManhoursOthers
      )
        errorObj.injuryInfoRequired = "Please enter a value.";
      if (form.isPersonalInjury && !personalDetails.length)
        errorObj.isPersonalInjury = "Minimum one row is required.";
      if (form.isAssetIncident && !assetDetails.length)
        errorObj.isAssetIncident = "Minimum one row is required.";
      if (form.isVehicleIncident && !vehicleDetails.length)
        errorObj.isVehicleIncident = "Minimum one row is required.";
      if (form.reportEvidencesRequired && !evidences.length)
        errorObj.reportEvidencesRequired = "Minimum one row is required.";
      if (new Date(form.incidentDate).getTime() > new Date(form.reportDate).getTime())
        errorObj.reportDate =
          "Report Date - Time must be later than incident Date - Time.";

      setErrorForm(errorObj);
      setPersonalDetailsErrors(personalDetailsErrorArray);
      setAssetDetailsErrors(assetDetailsErrorArray);
      setVehicleDetailsErrors(vehicleDetailsErrorArray);
      setEvidencesErrors(evidencesErrorArray);
      setCapasErrors(capaErrorArray);

      if (form?.incidentDate && !isAfterHoursMinutes(form?.incidentDate)) {
        errorObj.incidentDate = "Incident time should be past time.";
        toastr.warning("Incident time should be past time!");
        setSaving(false);
        return;
      }

      if (validate || form.incidentStatus !== incidentStatuses.draft) {
        if (form.isPersonalInjury && form.peopleCount < 1)
          errorObj.peopleCount = "Please enter minimum 1 count.";

        for (const array of [
          personalDetailsErrorArray,
          assetDetailsErrorArray,
          vehicleDetailsErrorArray,
          evidencesErrorArray,
          //capaErrorArray,
        ])
          for (const errObj of array)
            for (const key in errObj)
              if (errObj[key]) {
                flag = 1;
                break;
              }
      }

      for (const key in errorObj)
        if (errorObj[key]) {
          flag = 1;
          break;
        }

      for (const errObj of capaErrorArray)
        for (const key in errObj)
          if (errObj[key]) {
            capaFlag = 1;
            break;
          }

      // console.log("flag", flag);
      // console.log("errorObj", errorObj);

      let LtFlag = 0;
      let msg = "";
      if (form.type === "lti") {
        msg = checkForLt(personalDetails);
        if (msg) {
          LtFlag = 1;
        }
      }

      if (flag !== 0) {
        // toastr.clear(toast);
        toastr.warning("Incident inputs missing. Please complete applicable sections!");
        // if (LtFlag !== 0) {
        //   toastr.error(msg);
        // }

        setSaving(false);
        return;
      }
      // else {
      //   if (LtFlag !== 0) {
      //     toastr.error(msg);
      //     setSaving(false);
      //     return;
      //   }
      // }

      if (form.closeIncident && capaFlag !== 0) {
        toastr.error("All above CAPAs have been completed required!");
        setSaving(false);
        return;
      }

      if (!onCallPopup) {
        const popupMssgText = GET_MSSG_WITH_VALIDATE_LTI_FATALITY(
          form,
          personalDetails,
          setIsOptionalPopup
        );
        if (popupMssgText) {
          setShow(true);
          setPopupMssg(popupMssgText);
          setSaving(false);
          setSubmitFlagPass({ incidentStatus, validate, dontGoBack });
          return;
        }
      }

      // if (
      //   form?.type === "fatality" &&
      //   !personalDetails?.find((d) => d?.outcome === "fatality" && d?.deleted !== 1)
      // ) {
      //   toastr.error("Outcome should be Atleast 1 fatality for fatality incident type");
      //   setSaving(false);
      //   return;
      // }

      // if (form?.isPersonalInjury && personalDetails?.length) {
      //   // const personalDetailsObj = personalDetails?.find((d) => d?.deleted !== 1) || {};
      //   if (
      //     personalDetails?.find((d) => d?.outcome === "fatality" && d?.deleted !== 1) &&
      //     form?.type !== "fatality" &&
      //     form?.type !== "lti"
      //   ) {
      //     toastr.error("Incident Type should be Fatality");
      //     setSaving(false);
      //     return;
      //   }
      //   if (
      //     personalDetails?.find((d) => d?.outcome === "lostTime" && d?.deleted !== 1) &&
      //     form?.type !== "lti" &&
      //     form?.type !== "fatality"
      //   ) {
      //     toastr.error("Incident Type should be LTI");
      //     setSaving(false);
      //     return;
      //   }
      // }

      setLoading(true);
      const formData = {
        ...form,
        incidentStatus:
          form.incidentStatus !== incidentStatuses.draft
            ? form.incidentStatus
            : incidentStatus,
        personalDetails: form.isPersonalInjury ? personalDetails : [],
        assetDetails: form.isAssetIncident ? assetDetails : [],
        vehicleDetails: form.isVehicleIncident ? vehicleDetails : [],
        evidences: form.reportEvidencesRequired ? evidences : [],
        capas,
      };
      console.log("form999999", formData);

      formData.reportAtLabel = getReportAtLabelByStatus(formData.incidentStatus);

      const response = form.id
        ? await updateIncidentReport(formData, form.id)
        : await createIncidentReport(formData);
      setLoading(false);

      // toastr.clear(toast);

      if (!response?.status) {
        toastr.error(response?.message);
        setSaving(false);
        return;
      }

      toastr.success(params.id ? response?.message : response?.message);

      setForm((prev) => ({ ...prev, id: +response.data.id }));

      setPersonalDetails((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.personalDetails?.[i]?.id || null;
          return d;
        })
      );
      setAssetDetails((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.assetDetails?.[i]?.id || null;
          return d;
        })
      );
      setVehicleDetails((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.vehicleDetails?.[i]?.id || null;
          return d;
        })
      );

      setEvidences((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.evidences?.[i]?.id || null;
          return d;
        })
      );

      setCapas((prev) =>
        prev.map((d, i) => {
          if (d.id) return d;
          d.id = response.data.capas?.[i]?.id || null;
          return d;
        })
      );

      setSaving(false);

      if (dontGoBack) return;

      form.incidentStatus !== incidentStatuses.draft
        ? history.goBack()
        : history.push(
            (params.siteId ? `/sites/${params.siteId}` : "") +
              "/health-safety-and-environment/incident-management/my-incidents"
          );
    },
    [
      assetDetails,
      evidences,
      form,
      history,
      params.id,
      params.siteId,
      personalDetails,
      vehicleDetails,
      capas,
      saving,
    ]
  );

  const confirmationAlert = useCallback(() => {
    confirmAlert({
      title: "No LTI information has been entered.",
      message: "Are you sure you want to proceed?",
      buttons: [
        {
          label: "Yes",
          onClick: (e) => {
            onSubmit(
              submitFlagPass?.incidentStatus,
              submitFlagPass?.validate,
              submitFlagPass?.dontGoBack,
              true
            );
          },
        },
        {
          label: "No",
          onClick: () => {
            setIsOptionalPopup(false);
          },
        },
      ],
    });
  }, [
    onSubmit,
    submitFlagPass?.dontGoBack,
    submitFlagPass?.incidentStatus,
    submitFlagPass?.validate,
  ]);

  const handleClose = () => {
    setShow(false);
    setPopupMssg("");
    // setIsOptionalPopup(false);
    isOptionalPopup && confirmationAlert();
  };

  /************************* Use Effetct **********************/

  useEffect(() => {
    if (!params.siteId || !states.length || !sites.length) return;

    const state = states.find(
      (state) => state.id === +sites.find((site) => site.id === +params.siteId)?.stateId
    );

    setForm((prev) => ({
      ...prev,
      stateMasterId: state?.id || "",
      countryMasterId: state?.country_master?.id || "",
    }));
  }, [params.siteId, states, sites]);

  useEffect(() => {
    if (!params.id) return;

    getIncidentReportById(params.id, "role=Reporter").then((response) => {
      if (!response?.data) return;

      const {
        personalDetails,
        vehicleDetails,
        assetDetails,
        spills,
        evidences,
        staffType,
        capas,
        ...form
      } = response.data;

      setForm((prev) => {
        if (form.site?.siteType === 3) {
          prev.roName = form.site?.parentSite?.name;
          prev.roSiteId = form.site?.parentSite?.siteId;
        } else if (form.site?.siteType === 2) {
          prev.roName = form.site?.name;
          prev.roSiteId = form.site?.siteId;
        } else {
          prev.roName = "";
          prev.roSiteId = "";
        }

        return {
          ...prev,
          ...form,
          locationSiteId: form.site?.siteId,
          staffType: staffType,
          countryMasterId: form.state.country_master?.id,
          reportDate: normalizeDateTime(form.reportDate),
          incidentDate: normalizeDateTime(form.incidentDate),
          closeIncident: capas?.length ? true : false,
          peopleCount: assetDetails?.length,
        };
      });

      setPersonalDetails(
        personalDetails?.length
          ? personalDetails?.map((d) => ({ ...d, phone: d?.phone || "" }))
          : [JSON.parse(JSON.stringify(initialPersonalDetails))]
      );
      setVehicleDetails(
        vehicleDetails?.length
          ? vehicleDetails
          : [JSON.parse(JSON.stringify(initialVehicleDetails))]
      );
      setAssetDetails(
        assetDetails?.length
          ? assetDetails
          : [JSON.parse(JSON.stringify(initialAssetDetails))]
      );
      setCapas(
        capas?.length
          ? capas
          : [
              {
                ...initialCapa,
                // areaId: form.areaId,
                // subAreaId: form.subAreaId,
                capaOwners: form.capaOwners,
                ownerId: LOGGED_USER_ID(),
                siteId: form.siteId || null,
                workArea: form.workArea?.name || "",
                incidentDetailsId,
                source: "Incident Management",
                dueDate: form.incidentDate,
                completionDate: form.incidentDate,
              },
            ]
      );
      setEvidences(
        evidences?.length
          ? evidences?.filter((data) => data.category === evidenceCategories.report)
          : [JSON.parse(JSON.stringify(initialEvidence))]
      );
      // add constant
      // debugger;
      if (staffType === "contractor") {
        setDisableEmployer(false);
      }
    });
  }, [params.id]);

  useEffect(() => {
    if (!params.id) return;
    if (!area.length) return;
    if (form.areaId) {
      let filterData = [];
      setSubArea(filterData);
      if (area.length) {
        filterData = area.find((x) => x.id === form.areaId).subAreaOfOperation;
        const subAreaResult = filterData.filter((x) => x.id === 999);
        if (!subAreaResult.length) {
          filterData.push({ id: 999, name: "Other" });
        }
        let subAreaData = [...filterData];
        if (subAreaData.length) {
          setSubArea(subAreaData);
        }
      }

      //   let subAreaData = area.find(x => x.id === form.areaId).subAreaOfOperation;

      //   if (subAreaData.length) {
      //     const subAreaOther = { id: 999, name: "Other" }
      //     subAreaData.push(subAreaOther);
      //     setSubArea(subAreaData)
      //   }
      // }
    }
  }, [params.id, area, form.areaId]);

  // Sub Activity Data Fetch On Edit Time

  useEffect(() => {
    if (!params.id) return;
    if (!activity.length) return;
    if (form.activityId) {
      let subActivityData = activity.find((x) => x.id === form.activityId).subActivity;

      if (subActivityData.length) {
        setSubActivity(subActivityData);
      }
    }
  }, [params.id, activity, form.activityId]);

  // Incident Regional Office Data Fetch On Edit Time

  // useEffect(() => {
  //   if (!params.id) return;
  //   if (!sites.length) return;

  //   if (form.roId) {
  //     let roName = sites.find((x) => x.parentSiteId === form.roId).parentSite
  //       .name;
  //     if (roName) {
  //       setForm((prev) => ({
  //         ...prev,
  //         roName: roName,
  //       }));
  //     }
  //   }
  // }, [params.id, sites]);

  // Reported By Staff Employer Data Fetch On Edit Time

  // useEffect(
  //   (staffType) => {
  //     if (!params.id) return;
  //     if (!contractors.length) return;

  //     if (form.staffType === "contractor" && form.staffEmployer) {
  //       let GetstaffName = contractors.find(
  //         (x) => x.id == form.staffEmployer
  //       ).contractorPersons;
  //       if (GetstaffName) {
  //         setContractorsStaff(GetstaffName);
  //       }
  //     }
  //   },
  //   [params.id, contractors, form.staffType]
  // );

  useEffect(() => {
    if (form.severity > 3) {
      setForm((prev) => ({
        ...prev,
        closeIncident: false,
      }));
    }
  }, [form.severity]);

  useEffect(() => {
    StateService.getStateAll().then((response) => {
      if (!response?.data) return;

      setStates(response.data.stateMaster);
    });
    CountryService.getCountryAll().then((response) => {
      if (!response?.data) return;

      setCountries(response.data.countryMaster);
    });

    UserService.getUsers("filter[status]=1").then((response) => {
      if (!response?.data) return;

      setUsers(response.data);
    });

    // getContractor().then((response) => {
    //   if (!response?.data) return;

    //   setContractors(response.data);
    // });

    getAllSites("filter[status]=1&filter[activeStatus]=active").then((response) => {
      if (!response?.data) return;

      setSites(response.data);
    });
    // MeterialMasterServices.getMeterialMaster("filter[status]=1").then((response) => {
    //     if (!response?.data) return;

    //     const detailsArray = [];
    //     response.data.MaterialMaster.forEach((obj) => {
    //         detailsArray.splice(detailsArray.length, 0, ...obj.mat_material_master_level_details.filter((obj) => +obj.status === 1));
    //     });
    //     setMats(response.data.MaterialMaster);
    //     setMatDetails(detailsArray);
    // });

    getAllAreaOfOperation().then((response) => {
      if (!response?.data) return;
      setArea(response.data);
    });

    getAllActivity().then((response) => {
      if (!response?.data) return;
      setActivity(response.data);
    });

    getDepartment("filter[status]=1").then((response) => {
      if (!response?.data) return;
      let sortListByName = response.data.departments.sort((a, b) =>
        SORT_BY_ALPHABETICALLY(a, b, "name")
      );
      setDepartments(sortListByName);
    });

    getCapaOwner().then((response) => {
      if (!response?.data) return;
      setCapaOwners(response.data.capaOwners);
    });
  }, []);

  useEffect(() => {
    setContractorsStaff(
      contractorPersons
        ?.filter((obj) => obj?.employmentStatus === "active")
        .map((d, i) => ({
          ...d,
          name_aadharNumber_srNo: `${capitalizeName(d.firstName + " " + d.lastName)} / ${
            d.aadharNumber
          } / ${d.srNo}`,
        }))
    );

    setEmployeeList(
      employees
        ?.filter((obj) => obj?.employmentStatus === "active")
        .map((d, i) => ({
          ...d,
          name_email_employeeId: `${capitalizeName(d.firstName + " " + d.lastName)} / ${
            d.email
          } / ${d.employeeId}`,
        }))
    );
  }, [contractorPersons, employees]);

  const addCapa = () => {
    // if (!form.areaId || !form.subAreaId) return toastr.info("Please Select Area and Sub Area First");
    // console.log("/***/*//form", form);
    setCapas((previous) => [
      ...previous,
      {
        ...initialCapa,
        // areaId: form.areaId,
        // subAreaId: form.subAreaId,
        capaOwners: form.capaOwners,
        ownerId: LOGGED_USER_ID(),
        siteId: form.siteId || null,
        workArea: form.workArea?.name || "",
        incidentDetailsId,
        source: "Incident Management",
        dueDate: form.incidentDate,
        completionDate: form.incidentDate,
      },
    ]);
  };
  const deleteCapa = (index) =>
    setCapas((previous) =>
      previous
        .map((data, idx) =>
          idx !== index ? data : data.id ? { ...data, deleted: 1 } : null
        )
        .filter((data) => !!data)
    );
  const onChangeCapa = ({ name, value, type, checked, index }) => {
    setCapas((prevCapas) =>
      prevCapas.map((data, idx) => {
        if (idx !== index) return data;
        if (name === "areaId") {
          data["subAreaId"] = "";
        }
        data[name] = type === "checkbox" ? checked : value;
        return data;
      })
    );
  };

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Incident Management",
            path: "/health-safety-and-environment/incident-management",
          },
          {
            name: "Report Incident",
            // path: "/health-safety-and-environment/incident-management/my-approval-incidents",
          },
          // {
          //   name: "Edit",
          // },
        ]}
        module={ACTIVE_MODULE.incident}
      />
      <div className="healthSafetyEnvironmentWrapper mt-3">
        <div className="healthSafetyEnvironmentWrapper">
          <div className="hseMenuLinks card">
            {form.incidentReviewsData?.length > 0 && (
              <a
                onClick={() => setTab(8)}
                className={`pointer${tab === 8 ? " active" : ""}`}
                href
              >
                Workflow Inputs
              </a>
            )}
            <a
              href
              onClick={() => setTab(1)}
              className={`pointer${tab === 1 ? " active" : ""}`}
            >
              Incident Info{" "}
              <GoPrimitiveDot
                className={`${tabComplete?.["1"] ? "text-success" : "text-danger"}`}
              />
            </a>
            <a
              href
              onClick={() => setTab(2)}
              className={`pointer${tab === 2 ? " active" : ""}`}
            >
              General Info{" "}
              <GoPrimitiveDot
                className={`${tabComplete?.["2"] ? "text-success" : "text-danger"}`}
              />
            </a>
            <a
              href
              onClick={() => setTab(3)}
              // style={{pointerEvents: 'none'}}
              className={`pointer${tab === 3 ? " active" : ""}`}
            >
              Personnel Details{" "}
              <GoPrimitiveDot
                className={`${
                  tabComplete?.["3"] && personnelDetailsTabComplete
                    ? "text-success"
                    : "text-danger"
                }`}
              />
            </a>
            <a
              href
              onClick={() => setTab(4)}
              className={`pointer${tab === 4 ? " active" : ""}`}
            >
              Equipment Details{" "}
              <GoPrimitiveDot
                className={`${
                  tabComplete?.["4"] && equipmentDetailsTabComplete
                    ? "text-success"
                    : "text-danger"
                }`}
              />
            </a>
            <a
              href
              onClick={() => setTab(5)}
              className={`pointer${tab === 5 ? " active" : ""}`}
            >
              Vehicle Details{" "}
              <GoPrimitiveDot
                className={`${
                  tabComplete?.["5"] && vehicleDetailsTabComplete
                    ? "text-success"
                    : "text-danger"
                }`}
              />
            </a>
            <a
              href
              onClick={() => setTab(6)}
              className={`pointer${tab === 6 ? " active" : ""}`}
            >
              Evidence{" "}
              <GoPrimitiveDot
                className={`${
                  tabComplete?.["6"] && evidenceTabComplete
                    ? "text-success"
                    : "text-danger"
                }`}
              />
            </a>
            {form.closeIncident === true ? (
              <a
                href
                onClick={() => setTab(7)}
                className={`pointer${tab === 7 ? " active" : ""}`}
              >
                CAPA{" "}
                <GoPrimitiveDot
                  className={`${capaTabComplete ? "text-success" : "text-danger"}`}
                />
              </a>
            ) : null}
          </div>
        </div>
        <div className="p-2">
          {tab === 1 && (
            <IncidentInfoTab
              form={form}
              onChange={onChange}
              error={errorForm}
              onChangeDate={onChangeDate}
              sites={sites}
              countries={countries}
              states={states}
              departments={departments}
              setTab={setTab}
              onSubmit={onSubmit}
              area={area}
              subArea={subArea}
              activity={activity}
              subActivity={subActivity}
              users={users}
              employeeList={employeeList}
              contractors={contractors}
              disableEmployer={disableEmployer}
              contractorsStaff={contractorsStaff}
              otherSubArea={otherSubArea}
              // onChangeAreaId={onChangeAreaId}
            />
          )}

          {tab === 2 && (
            <GeneralInfoTab
              form={form}
              onChange={onChange}
              error={errorForm}
              setTab={setTab}
              onSubmit={onSubmit}
            />
          )}

          {tab === 3 && (
            <PersonnelDetailsTab
              form={form}
              onChange={onChange}
              error={errorForm}
              setTab={setTab}
              onSubmit={onSubmit}
              personalDetails={personalDetails}
              personalDetailsErrors={personalDetailsErrors}
              onChangePersonalDetails={onChangePersonalDetails}
              onChangePersonalDetailsEmployee={onChangePersonalDetailsEmployee}
              deleteRowPersonalDetails={deleteRowPersonalDetails}
              addRowPersonalDetails={addRowPersonalDetails}
              users={users}
              contractors={contractors}
              employeeList={employeeList}
              contractorsStaff={contractorsStaff}
            />
          )}

          {tab === 4 && (
            <EquipmentDetailsTab
              form={form}
              onChange={onChange}
              error={errorForm}
              setTab={setTab}
              onSubmit={onSubmit}
              assetDetails={assetDetails}
              matDetails={matDetails}
              onChangeAssetDetailsSku={onChangeAssetDetailsSku}
              onChangeAssetDetailsSkuInput={onChangeAssetDetailsSkuInput}
              mats={mats}
              assetDetailsErrors={assetDetailsErrors}
              onChangeAssetDetails={onChangeAssetDetails}
              deleteRowAssetDetails={deleteRowAssetDetails}
              addRowAssetDetails={addRowAssetDetails}
            />
          )}
          {tab === 5 && (
            <VehicleDetailsTab
              form={form}
              onChange={onChange}
              error={errorForm}
              setTab={setTab}
              onSubmit={onSubmit}
              vehicleDetails={vehicleDetails}
              vehicleDetailsErrors={vehicleDetailsErrors}
              onChangeVehicleDetails={onChangeVehicleDetails}
              deleteRowVehicleDetails={deleteRowVehicleDetails}
              addRowVehicleDetails={addRowVehicleDetails}
            />
          )}

          {tab === 6 && (
            <IncidentEvidenceTab
              form={form}
              onChange={onChange}
              error={errorForm}
              setTab={setTab}
              onSubmit={onSubmit}
              evidences={evidences}
              evidencesErrors={evidencesErrors}
              onChangeEvidence={onChangeEvidence}
              onChangeEvidenceFile={onChangeEvidenceFile}
              addEvidence={addEvidence}
              deleteEvidence={deleteEvidence}
            />
          )}
          {tab === 7 && form.closeIncident === true ? (
            <IncidentCapaTab
              form={form}
              onChange={onChange}
              error={errorForm}
              setTab={setTab}
              onSubmit={onSubmit}
              capas={capas}
              capasErrors={capasErrors}
              onChangeCapa={onChangeCapa}
              addCapa={addCapa}
              deleteCapa={deleteCapa}
              area={area}
              capaowner={capaOwners}
              subArea={subArea}
              departments={departments}
              users={users}
              siteId={form?.siteId}
            />
          ) : null}

          {tab === 8 && (
            <>
              <Col lg={12} className="pt-3">
                <ViewComments
                  comments={form.incidentReviewsData ? form.incidentReviewsData : []}
                />

                {/* <span
                className="pointer btn btn-right"
                onClick={() => {
                  setTab(1);
                  // if (!noBack) onSubmit(incidentStatuses.draft, false, true);
                }}
              >
                {`Next`}
                <BsArrowRight />
              </span> */}
              </Col>
            </>
          )}
          <ErrorPopup
            show={show}
            popupMssg={popupMssg}
            handleClose={handleClose}
            isOptionalPopup={isOptionalPopup}
          />
          {loading && <NetZeroLoader addZIndex={true} />}
        </div>
        <div className="mt-4 text-center">
          <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
            Go Back to Main Menu
          </span>
        </div>
      </div>
    </>
  );
};

export const ButtonsContainer = ({
  setTab,
  onSubmit,
  noBack,
  noNext,
  incidentStatus,
  closeIncident,
}) => (
  <div className="stepperFormButtons mt-4">
    {noBack ? (
      <span style={{ width: 150 }} />
    ) : (
      <span className="pointer btn btn-left" onClick={() => setTab((prev) => prev - 1)}>
        <BsArrowLeft /> Back
      </span>
    )}
    {noNext ? (
      <span
        className="pointer btn btn-right"
        onClick={() => onSubmit(incidentStatuses.draft, false)}
      >
        Save{incidentStatus === incidentStatuses.draft ? " As Draft" : ""}
        <BsArrowRight />
      </span>
    ) : (
      <span
        className="pointer btn btn-right"
        onClick={() => {
          setTab((prev) => prev + 1);
          // if (!noBack) onSubmit(incidentStatuses.draft, false, true);
        }}
      >
        {`Next`}
        <BsArrowRight />
      </span>
    )}

    {noNext && (
      <span
        className="pointer btn btn-right"
        onClick={() =>
          onSubmit(closeIncident ? incidentStatuses.closed : incidentStatuses.open)
        }
      >
        {getSubmitButtonText(closeIncident)}
        <BsArrowRight />
      </span>
    )}
  </div>
);

export default ManageIncidentReport;
